import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import { TranslationService } from '@/utils/services/TranslationService';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Hooks
import useStateWithReset from '@/utils/hooks/utils/useStateWithReset';

// Routes
import { SIGN_UP, SIGN_UP_URL_PATHNAME } from '@/lib/routes/privateRoutes';

// Components
import InfoBanner from '@/components/base/InfoBanner';
import LayoutSignUpLogged from '@/components/layouts/LayoutSignUpLogged';
import SocialProfilesAdded from '@/components/pages/signup/connectSocialProfiles/SocialProfilesAdded';
import SocialProfilesConnect from '@/components/pages/signup/connectSocialProfiles/SocialProfilesConnect';
const ModalSocialProfilesToAdd = dynamic(
    () => import('@/components/pages/signup/connectSocialProfiles/ModalSocialProfilesToAdd')
);

const PageContent = () => {
    const { t: tErrors } = useTranslation('errors');
    const { t: tCommons } = useTranslation('commons');
    const { t: tSignupFunnel } = useTranslation('signup_funnel');
    const router = useRouter();

    const [
        failedToAddSocialProfiles,
        setFailedToAddSocialProfiles,
        resetFailedToAddSocialProfiles
    ] = useStateWithReset(false);

    useEffect(() => {
        // Prefetch the user infos page
        router.prefetch(SIGN_UP.USER_CREATED);
        router.prefetch(SIGN_UP.SOCIAL_PROFILES_CONNECTED);
    }, [router]);

    return (
        <>
            <LayoutSignUpLogged.MainContent
                title={tSignupFunnel('connect_social_profiles.title')}
                subtitle={tSignupFunnel('connect_social_profiles.subtitle')}>
                {failedToAddSocialProfiles ? (
                    <InfoBanner
                        className="mt-m"
                        title={tErrors('error')}
                        message={tCommons('list_social_profiles.error_add_some_social_profiles')}
                        onClose={resetFailedToAddSocialProfiles}
                    />
                ) : null}
                <SocialProfilesConnect />
            </LayoutSignUpLogged.MainContent>
            <LayoutSignUpLogged.SideContent hideOnMobile={true}>
                <div className="h-full w-full bg-icoGray-100 px-12 py-10">
                    <SocialProfilesAdded />
                </div>
            </LayoutSignUpLogged.SideContent>
            <ModalSocialProfilesToAdd
                onFailure={() => {
                    setFailedToAddSocialProfiles(true);
                }}
            />
        </>
    );
};

const ConnectSocialProfiles = () => {
    return (
        <LayoutSignUpLogged>
            <PageContent />
        </LayoutSignUpLogged>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(
    SIGN_UP_URL_PATHNAME.USER_SET_UP
);

export default ConnectSocialProfiles;
